/**
 * YITH Color Label Variations clears the attribute when the already selected
 * swatch is clicked again (assets/js/yith-wccl.js, "if ( selected )" branch).
 * Variation attributes are always required, so leave the customer no way to
 * end up with an empty selection.
 *
 * The plugin binds its handler directly on the swatch, so stopping the event
 * during the capture phase keeps that handler from running at all. Only the
 * ".selected" swatch is blocked - clicking an ".inactive" one still resets the
 * form, which is how customers escape an unavailable combination.
 */
export const preventAttributeDeselect = () => {
  document.addEventListener(
    "click",
    (event) => {
      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      const selectedOption = target.closest(
        "form.variations_form .select_option.selected"
      );

      if (!selectedOption) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
};
